import { render, staticRenderFns } from "./ChannelSortAndLock.vue?vue&type=template&id=5407ad74"
import script from "./ChannelSortAndLock.vue?vue&type=script&lang=ts"
export * from "./ChannelSortAndLock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports